export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SingleHeader.vue?vue&type=template&id=58ab7607&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleHeader.vue?vue&type=template&id=58ab7607&scoped=true&
// module id = 287
// module chunks = 0